module.exports = __webpack_public_path__ + "static/media/pn.2d4ce209.svg";